import { IQueryParamsBaseRecord, defaultQueryParamsBase } from "common/records/index/QueryParamsBase";
import { Nullable } from "common/types";
import { List, Record } from "immutable";

export const orgParamsFromJSON = (data: IOrgParamsData) => {
  const record = { ...(data as any) };

  if (record["status[]"]) {
    record["status[]"] = List(record["status[]"]);
  }

  return new OrgParamsRecord(record);
};

export interface IOrgParamsData extends Partial<IQueryParamsBaseRecord> {
  parent_id?: Nullable<number>;
  "status[]"?: Nullable<string[]>;
}

export interface IOrgParamsRecord extends IQueryParamsBaseRecord {
  parent_id: Nullable<number>;
  "status[]": Nullable<List<string>>;
}

const defaultOrgParams: IOrgParamsRecord = {
  ...defaultQueryParamsBase,
  parent_id: null,
  sort_by: "id",
  sort_order: "desc",
  "status[]": null,
};

export class OrgParamsRecord extends Record(defaultOrgParams) implements IOrgParamsRecord {}
